import { initAxiosRH, loadAbort } from "#api/axios.service"
const axios=initAxiosRH()
const CANDIDATE="talent_cloud/candidate"
const CANDIDATE_FILE_TYPE=`${CANDIDATE}/file_type`
const CANDIDATE_FILE=(id)=>`${CANDIDATE}/${id}/file`
const CANDIDATE_HISTORY=(id)=>`${CANDIDATE}/${id}/history`
const CANDIDATE_INTERVIEW=(id)=>`${CANDIDATE}/${id}/interview`
const CANDIDATE_EVALUATION=(id)=>`${CANDIDATE}/${id}/evaluation`
const CANDIDATE_WORK_HISTORY=(id)=>`${CANDIDATE}/${id}/work_history`
const CANDIDATE_QUESTIONS=(id)=>`${CANDIDATE}/${id}/questions`


export const candidateGet = (params) => {
    const controller= loadAbort()
    const call= axios.get(CANDIDATE,{params,signal:controller.signal})
    return {call,controller}
}

export const candidateIdGet = ({id,params}) => {
    const controller= loadAbort()
    const call= axios.get(`${CANDIDATE}/${id}`,{params,signal:controller.signal})
    return {call,controller}
}
export const candidateIdPut = (id,data,params) => {
    const controller= loadAbort()
    const call= axios.put(`${CANDIDATE}/${id}`,data,{params,signal:controller.signal})
    return {call,controller}
}

// CANDIDATE interview

export const candidateIdInterviewPost = (id,data,params) => {
    const controller= loadAbort()
    const call= axios.post(`${CANDIDATE_INTERVIEW(id)}`,data,{params,signal:controller.signal})
    return {call,controller}
}

//CANDIDATE_FILE

export const candidateIdFileGet = ({id,params}) => {
    const controller= loadAbort()
    const call= axios.get(CANDIDATE_FILE(id),{params,signal:controller.signal})
    return {call,controller}
}

export const candidateIdFilePost = (id,data,params) => {
    const controller= loadAbort()
    const call= axios.post(CANDIDATE_FILE(id),data,{params,signal:controller.signal})
    return {call,controller}
}

export const candidateIdFileIdGet = ({candidateId,fileId,params}) => {
    const controller= loadAbort()
    const call= axios.get(`${CANDIDATE_FILE(candidateId)}/${fileId}`,{params,signal:controller.signal})
    return {call,controller}
}
export const candidateIdFileIdPut = (candidateId,fileId,data,params) => {
    const controller= loadAbort()
    const call= axios.put(`${CANDIDATE_FILE(candidateId)}/${fileId}`,data,{params,signal:controller.signal})
    return {call,controller}
}
export const candidateIdFileIdDelete = (candidateId,fileId,params) => {
    const controller= loadAbort()
    const call= axios.delete(`${CANDIDATE_FILE(candidateId)}/${fileId}`,{params,signal:controller.signal})
    return {call,controller}
}

export const candidateHistoryGet = ({id,params}) => {
    const controller= loadAbort()
    const call= axios.get(CANDIDATE_HISTORY(id),{params,signal:controller.signal})
    return {call,controller}
}

//CANDIDATE_FILE_TYPE
export const candidateFileTypeGet = (params) => {
    const controller= loadAbort()
    const call= axios.get(CANDIDATE_FILE_TYPE,{params,signal:controller.signal})
    return {call,controller}
}

export const candidateFileTypePost = (data,params) => {
    const controller= loadAbort()
    const call= axios.post(CANDIDATE_FILE_TYPE,data,{params,signal:controller.signal})
    return {call,controller}
}

export const candidatePost = (data,params) => {
    const controller= loadAbort()
    const call= axios.post(CANDIDATE,data,{params,signal:controller.signal})
    return {call,controller}
}
// CANDIDATE_EVALUATION
export const candidateEvaluationGet = ({id, params}) => {
    const controller= loadAbort()
    const call= axios.get(CANDIDATE_EVALUATION(id),{params,signal:controller.signal})
    return {call,controller}
}
export const candidateEvaluationDelete = ({id, interview,params}) => {
    const controller= loadAbort()
    const call= axios.delete(`${CANDIDATE_EVALUATION(id)}/${interview}`,{params,signal:controller.signal})
    return {call,controller}
}
// CANDIDATE_WORK_HISTORY
export const candidateWorkHistoryGet = ({id, params}) => {
    const controller= loadAbort()
    const call= axios.get(CANDIDATE_WORK_HISTORY(id),{params,signal:controller.signal})
    return {call,controller}
}
// CANDIDATE_QUESTIONS
export const candidateQuestionsGet = ({id, params}) => {
    const controller= loadAbort()
    const call= axios.get(CANDIDATE_QUESTIONS(id),{params,signal:controller.signal})
    return {call,controller}
}